import {createAnatomy} from '@zag-js/anatomy';

export const selectAnatomy = createAnatomy(`select`).parts(`option`, `control`, `menuList`);

export const parts = selectAnatomy.build();

export type Part = keyof typeof parts;
